import React from "react";
import hamburger from "../../images/hamburger.svg";
const Filter = () => {
  return (
    <div className="">
      <div className="row">
        <div className="col-md-12">
          <div className="allbtn">
            <div className="all pt-2">
              <div className="d-flex align-items-center justify-content-center">
                <img src={hamburger} alt="" />
                <h5>All</h5>
              </div>
            </div>
            <button>
              <select name="" id="">
                <option value="">Drones</option>
              </select>
            </button>
            <button>
              <select name="" id="">
                <option value="">Price</option>
              </select>
            </button>
            <button>Free Cancellation</button>
            <button>Wifi</button>
            <button>Bluetooth</button>
            <button>Power system</button>
            <button>Load</button>
            <button>4K</button>
            <button>Motor</button>
            <button>
              <i class="fa fa-filter" aria-hidden="true"></i> Filter
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Filter;
